import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
// import { FiDribbble } from "react-icons/fi";

const headerSocial = () => {
  return (
    <div className="header_social">
      <a
        href="https://www.linkedin.com/in/yann-nguessan-53a1a220a/"
        target="_blank"
        rel="noreferrer"
      >
        <BsLinkedin />
      </a>
      <a href="https://github.com/Yannamon" target="_blank" rel="noreferrer">
        <FaGithub />
      </a>
      {/* <a href="https://dribble.com" target="_blank" rel="noreferrer">
        <FiDribbble />
      </a> */}
    </div>
  );
};

export default headerSocial;
